/* angular stuff */
import { NgModule, Optional, SkipSelf, ErrorHandler } from '@angular/core';
import { CommonModule } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

/* 3rd party libraries */
import { BsDatepickerModule } from 'src/app/shared/vendor';
/* our own stuff */
import { throwIfAlreadyLoaded } from './guards/module-import.guard';
import { CoreExceptionHandler } from './core.exception.handler';
import { NotFoundComponent } from './not-found/not-found.component';
import { TokenInterceptor } from './interceptors/token-interceptor.service';
import { TitleService } from './services/title.service';
import { WebStorageService } from './services/web-storage.service';
import { SpinnerService } from './services/spinner.service';
// Modals
import { AccountMultiListComponent } from './../features/ac/components/forms/modals/account-multi-list.component';
import { CostCenterListComponent } from './../features/ac/components/forms/modals/cost-center-list.component';
import { BankDetailComponent } from './../features/ac/components/forms/modals/bank-detail.component';
// import { VoucherSearchComponent } from './../features/ac/components/forms/modals/voucher-search.component';
import { AccountsListPeriodSetupComponent } from './../features/ac/components/forms/modals/accounts-list-period-setup.component';
import { BaListPeriodSetupComponent } from './../features/ac/components/forms/modals/ba-list-period-setup.component';
import { CostCenterListPeriodSetupComponent } from './../features/ac/components/forms/modals/cost-center-list-period-setup.component';
import { ParentListComponent } from './../features/ac/components/forms/modals/parent-list.component';
import { NatureListComponent } from './../features/ac/components/forms/modals/nature-list.component';
import { ConveyanceBillAccountsComponent } from './../features/ac/components/forms/modals/conveyance-bill-accounts.component';
import { AccountsListComponent } from './../features/ac/components/forms/modals/accounts-list.component';
// import { OtherBillAccountsComponent } from '../features/ac/components/forms/modals/other-bill-accounts.component';
import { VoucherAccessListComponent } from '../features/ac/components/forms/modals/voucher-access-list.component';
import { EmployeeListComponent } from '../features/ac/components/forms/modals/employee-list.component';
import { UserListComponent } from '../features/ac/components/forms/modals/user-list.component';
import { SharedModule } from '../shared/shared.module';
import { CostCenterNameListComponent } from '../features/ac/components/forms/modals/cost-center-name-list.component';
import { MapReferencePIListComponent } from '../features/ac/components/forms/modals/map-reference-PI-list.component';
import { MapReferanceInvoiceListComponent } from '../features/ac/components/forms/modals/map-reference-invoice.component';
import { ChequeNoComponent } from '../features/ac/components/forms/modals/cheque-no.component';
import { BankNameComponent } from '../features/ac/components/forms/modals/bank-name.component';
import { VoucherNoListComponent } from '../features/ac/components/forms/modals/voucher-no-list.component';
import { ReportListComponent } from '../features/ac/components/forms/modals/report-list.component';
import { DeptNameListComponent } from '../features/ac/components/forms/modals/dept-name-list.component';
import { BankNameListComponent } from '../features/ac/components/forms/modals/bank-name-list.component';
import { DeptNameListTransferComponent } from '../features/ac/components/forms/modals/dept-name-list-transfer.component';
import { ChequeBookListComponent } from '../features/ac/components/forms/modals/cheque-book-id.component';
import { VoucherTypeListComponent } from '../features/ac/components/forms/modals/voucher-type.component';
import { BudgetListComponent } from '../features/ac/components/forms/modals/budget-list.component';
import { AccountsListTransferComponent } from '../features/ac/components/forms/modals/account-list-transfer.component';
import { BudgetTransferEntryComponent } from '../features/ac/components/forms/modals/budget-transfer-entry.component';
import { BankAccountsListComponent } from '../features/ac/components/forms/modals/bank-account-list.component';
import { ReferancePeriodSetupComponent } from '../features/ac/components/forms/modals/referance-center.componenet';
// import { UserListWithJobtitleComponent } from '../features/ac/components/forms/modals/user-list-with-jobtitle.component';
import { PayToNameListComponent } from '../features/ac/components/forms/modals/pay-to-name-list.component';
import { ChequeTypeListComponent } from '../features/ac/components/forms/modals/cheque-type-list.component';
import { RequestCache } from './services/request-cache.service';
import { ReferanceCenterListComponent } from '../features/ac/components/forms/modals/referance-center-list';
import { AccountsListWithPathComponent } from '../features/ac/components/forms/modals/account-list-with-path.component';
//import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ToastrModule } from 'ngx-toastr';
import { LedgerListComponent } from '../features/ac/components/forms/modals/ledger-list.component';
import { BankBranchNameListComponent } from '../features/ac/components/forms/modals/bank-branch.component';
import { CostCenterListComponent1 } from '../features/ac/components/forms/modals/cost-center-list1.component';
import { ImportLcNoListComponent } from '../features/ac/components/forms/modals/import-lc-no.component';
// import { ExportLcNoListComponent } from '../features/ac/components/forms/modals/export-lc-no.component';
import { CustomerListComponent } from '../features/ac/components/forms/modals/customer-list.component';
import { SalesContractListComponent } from '../features/ac/components/forms/modals/sales-contract-list.component';
import { DocumentListComponent } from '../features/ac/components/forms/modals/document-list.component';
import { InvoiceDistributionComponent } from '../features/ac/components/forms/modals/invoice-distribution.component';
// import { InvoiceDistributionWithDescComponent } from '../features/ac/components/forms/modals/invoice-distribution-with-desc.component';
import { InventoryListComponent } from '../features/ac/components/forms/modals/inventory-list.component';
import { AccountsOffestListComponent } from '../features/ac/components/forms/modals/account-offset-list.component';
import { AccountsAssertListComponent } from '../features/ac/components/forms/modals/account-assert-list.component';
import { DocumentLargeListComponent } from '../features/ac/components/forms/modals/document-large-list.component';
import { AttachableVoucherListComponent } from '../features/ac/components/forms/modals/attachable-voucher-list.component';
import { VendorModule } from '../shared/vendor/vendor.module';
import { DialogModule } from '../shared/modules/dialog.module';
import { SerialListComponent } from '../features/ac/components/forms/modals/serial-list.component';
import { OtherBillExpenceAccountsComponent } from '../features/ac/components/forms/modals/other-bill-expence-accounts.component';
// import { ConveyanceExpenseAccountsComponent } from '../features/ac/components/forms/modals/conveyance-expense-account.component';

import { JobTitleNameListComponent } from '../features/ac/components/forms/modals/employee-position-list.component';
import { LineListComponent } from '../features/ac/components/forms/modals/line-list.component';
// import { EmployeeTypePrefixListComponent } from '../features/hr/components/forms/modals/employee-type-prefix-list.component';
import { ShiftListComponent } from '../features/ac/components/forms/modals/shift-list.component';
import { ListRequestListComponent } from '../features/ac/components/forms/modals/list-request-list.copmonent';
// import { HrRequisitionNumberListComponent } from '../features/hr/components/forms/modals/hr-requision-number-list.component';
import { BusinessUnitListComponent } from '../features/hr/components/forms/modals/business-unit-list.component';
import { BankListComponent } from '../features/hr/components/forms/modals/bank-list.component';
import { ReportNameListComponent } from '../features/hr/components/forms/modals/report-name-list.component';
import { CompanyListComponent } from '../features/hr/components/forms/modals/company-list.component';
import { Employee1ListComponent } from '../features/ac/components/forms/modals/employee1-list.component';
import { Employee2ListComponent } from '../features/ac/components/forms/modals/employee2-list.component';
import { NewHrRequisitionLetterComponent } from '../features/hr/components/forms/modals/new-hr-requisition-letter.component';



import { AdvanceSearchComponent } from '../features/hr/components/forms/modals/advance-search.component';
import { NewCompanyListComponent } from '../features/hr/components/forms/modals/new-company_list.modal';
import { HrCompanyListComponent } from '../features/hr/components/forms/modals/hr-company-list.component';

// Purchace Modal 
// import { RequisitionListComponent } from '../features/in/components/forms/modals/requisition-list.component';
// import { CurrencyListComponent } from '../features/in/components/forms/modals/currency-list.component';
// import { SupplierListComponent } from '../features/in/components/forms/modals/supplier-list.component';
// import { ItemListComponent } from '../features/in/components/forms/modals/item-list.component';
// import { SourceTypeListComponent } from '../features/in/components/forms/modals/source-type-list.component';
// import { ItemHistoryListComponent } from '../features/in/components/forms/modals/item-history-list.component';
// import { PurchaseDetailsItemComponent } from '../features/in/components/forms/modals/purchase-details-item.component';
// import { ItemGroupListComponent } from '../features/in/components/forms/modals/item-group-list.component';
// import { WorkOrderStatusListComponent } from '../features/in/components/forms/modals/work-order-status-list.component';
// import { PurchaseContractStatusListComponent } from '../features/in/components/forms/modals/purchase-contract-status-list.component';
// import { BillReturnAccountsInformationComponent } from '../features/in/components/forms/modals/bill-return-accounts-information.component';
// import { RequisitionByStatusListComponent } from '../features/in/components/forms/modals/requisition-by-status-list.component';
// import { TermsAndConditionsComponent } from '../features/in/components/forms/modals/terms-and-conditions.component';
// import { SelectTaskComponent } from '../features/in/components/forms/modals/select-task.component';
// import { StoreItemListComponent } from '../features/in/components/forms/modals/store-item-list.component';
// import { ReportRequisitionListComponent } from '../features/in/components/forms/modals/report-requisition-list.component';
import { ReportNameComponent } from '../features/hr/components/forms/modals/report-name.component';
// import { StatusHistoryListComponent } from '../features/in/components/forms/modals/status-history-list.component';
// import { ItemParentListComponent } from '../features/in/components/forms/modals/item-parent-list.component';
// import { ContactPersonListComponent } from '../features/in/components/forms/modals/contact-person-list.component';
import { HrLineListOneComponent } from '../features/hr/components/forms/modals/hr-line-list-one.component';
import { HrBankNameListComponent } from '../features/hr/components/forms/modals/bank-name-list.component';

import { GradeListComponent } from '../features/hr/components/forms/modals/grade-list.component';
// import { SignatureByListComponent } from '../features/in/components/forms/modals/signature-by-list.component';
// import { SignatoryByListComponent } from '../features/in/components/forms/modals/signatory-by-list.component';
import { HrLineListComponent } from '../features/hr/components/forms/modals/hr-line.component';
// import { WorkOrderDetailInformationListComponent } from '../features/in/components/forms/modals/work-order-detail-information-list.component';
// import { StoreWiseOpBalListComponent } from '../features/in/components/forms/modals/store-wise-op-bal-list.component';
// import { StoreListComponent } from '../features/in/components/forms/modals/store-list.component';
// import { AccountInformationComponent } from '../features/in/components/forms/modals/accounts-information-component';
// import { VendorTypeListComponent } from '../features/in/components/forms/modals/vendor-type-list.component';
// import { ItemListTwoComponent } from '../features/in/components/forms/modals/item-list-two-component';
// import { LcTypeListComponent } from '../features/in/components/forms/modals/lc-type-list.component';
// import { AccountsInformationTwoComponent } from '../features/in/components/forms/modals/acccounts-information-two.component';
import { EmployeeListOneComponent } from '../features/hr/components/forms/modals/employee-list-one.component';
import { GradeListOneComponent } from '../features/hr/components/forms/modals/grade-list-one.component';
import { ReportNameListOneComponent } from '../features/hr/components/forms/modals/report-name-list-one.component';
// import { HrLetterComponent } from '../features/hr/components/forms/modals/hr-letter.component';
// import { BillIdListComponent } from '../features/in/components/forms/modals/bill-id-list.component';
// import { SupplierLargeListComponent } from '../features/in/components/forms/modals/supplier-large-list.component';
// import { WorkOrderListComponent } from '../features/in/components/forms/modals/work-order-list.component';
// import { ProformaInvoiceListComponent } from '../features/in/components/forms/modals/proforma-invoice-list.component';
// import { HrEmployeeListComponent } from '../features/hr/components/forms/modals/hr-employee-list.component';
// import { StoreTypeListComponent } from '../features/in/components/forms/modals/store-type-list.component';
// import { LcContractListComponent } from '../features/in/components/forms/modals/lc-contract-list.component';
// import { TransactionTypeListComponent } from '../features/in/components/forms/modals/transaction-type-list.component';
// import { TransactionListComponent } from '../features/in/components/forms/modals/transaction-list.component';
// import { PurchaseRequisitionComponent } from '../features/in/components/forms/modals/purchase-requisition.component';
// import { TermsAndConditionsComponentTwo } from '../features/in/components/forms/modals/terms-and-condition-two.component';
// import { TermListComponent } from '../features/in/components/forms/modals/term-list.component';
// import { TermsAndConditionsTemplateSetupComponent } from '../features/in/components/forms/modals/terms-and-condition-template-setup.component';
// import { GroupAccountListComponent } from '../features/in/components/forms/modals/group-account-list.component';
// import { SupplierPiComponent } from '../features/in/components/forms/modals/supplier-pi.component';
import { HrLineListTwoComponent } from '../features/hr/components/forms/modals/hr-line-list-two.component';
import { HrBusinessUnitList2Component } from '../features/hr/components/forms/modals/hr-business-unit-list2.component';
import { HrElementListComponent } from '../features/hr/components/forms/modals/hr-element-list.component';
import { HrShiftListComponent } from '../features/hr/components/forms/modals/hr-shift-list.component';
import { HrJobTypeListComponent } from '../features/hr/components/forms/modals/hr-job-type-list.component';
import { HrJobTitleListComponent } from '../features/hr/components/forms/modals/hr-job-title-list.component';
import { HrEmployeeList2Component } from '../features/hr/components/forms/modals/hr-employee-list2.component';
import { HrProcessListComponent } from '../features/hr/components/forms/modals/hr-process-list.component';
import { HrFloorListComponent } from '../features/hr/components/forms/modals/hr-floor-list.component';
// import { SupplierManufacturerComponent } from '../features/in/components/forms/modals/supplier-manufacturer.component';
// import { StoreComponent } from '../features/in/components/forms/modals/store.component';
// import { StockHistoryListComponent } from '../features/in/components/forms/modals/stock-history-list.component';
// import { CnfListComponent } from '../features/in/components/forms/modals/cnf-list.component';
import { HrReportListComponent } from '../features/hr/components/forms/modals/hr-report-list.component';
import { VehicleNoListComponent } from '../features/hr/components/forms/modals/vehicle-no-list.component';
import { VehicleTypeListComponent } from '../features/hr/components/forms/modals/vehicle-type-list.component';
import { PickPointListComponent } from '../features/hr/components/forms/modals/pick-point.component';
import { EmployeeListComponentTwo } from '../features/hr/components/forms/modals/employee-list.component-two';


/*============== HR Module Modals ===============*/
import { BusinessUnitOrgComponent } from '../features/hr/components/forms/modals/business-unit-org.component';
import { HrDateListComponent } from '../features/hr/components/forms/modals/hr-date-list.component';
import { HrComShiftComponent } from '../features/ac/components/forms/modals/hr-com-shift-list.component';
import { HrComLineComponent } from '../features/ac/components/forms/modals/hr-com-line-list.component';
import { HrFloorComponent } from '../features/ac/components/forms/modals/floor-list.component';
// import { ProformaInvoiceListComponentTwo } from '../features/in/components/forms/modals/proforma-invoice-list-two.component';
// import { HrReportNameListOneComponent } from '../features/hr/components/forms/modals/hr-report-name-list-one.component';
// import { TermsAndConditionsSetupComponent } from '../features/in/components/forms/modals/terms-and-condition-setup.component';
// import { TermsAndConditionsComponentThree } from '../features/in/components/forms/modals/terms-and-condition-three.component';
import { BaseComponent } from './base/base.component';
import { FormCanDeactivate } from './guards/form-can-deactivate/form-can-deactivate';
import { FormCommonComponent } from './base/form-common-component';

@NgModule({
    declarations: [
        NotFoundComponent,
        AccountMultiListComponent,
        CostCenterListComponent,
        CostCenterNameListComponent,
        BankDetailComponent,
        // VoucherSearchComponent,
        AccountsListPeriodSetupComponent,
        BaListPeriodSetupComponent,
        CostCenterListPeriodSetupComponent,
        ParentListComponent,
        NatureListComponent,
        ConveyanceBillAccountsComponent,
        AccountsListComponent,
        // OtherBillAccountsComponent,
        VoucherAccessListComponent,
        EmployeeListComponent,
        UserListComponent,
        MapReferencePIListComponent,
        MapReferanceInvoiceListComponent,
        ChequeNoComponent,
        BankNameComponent,
        VoucherNoListComponent,
        ReportListComponent,
        DeptNameListComponent,
        BankNameListComponent,
        DeptNameListTransferComponent,
        ChequeBookListComponent,
        VoucherTypeListComponent,
        BudgetListComponent,
        AccountsListTransferComponent,
        BudgetTransferEntryComponent,
        BankAccountsListComponent,
        ReferancePeriodSetupComponent,
        // UserListWithJobtitleComponent,
        PayToNameListComponent,
        ChequeTypeListComponent,
        ReferanceCenterListComponent,
        AccountsListWithPathComponent,
        LedgerListComponent,
        BankBranchNameListComponent,
        CostCenterListComponent1,
        ImportLcNoListComponent,
        // ExportLcNoListComponent,
        CustomerListComponent,
        SalesContractListComponent,
        DocumentListComponent,
        InvoiceDistributionComponent,
        // InvoiceDistributionWithDescComponent,
        InventoryListComponent,
        AccountsOffestListComponent,
        AccountsAssertListComponent,
        DocumentLargeListComponent,
        AttachableVoucherListComponent,
        SerialListComponent,
        OtherBillExpenceAccountsComponent,
        // ConveyanceExpenseAccountsComponent,
        JobTitleNameListComponent,
        LineListComponent,
        // EmployeeTypePrefixListComponent,
        ShiftListComponent,
        ListRequestListComponent,
        // HrRequisitionNumberListComponent,
        BusinessUnitListComponent,
        BankListComponent,
        ReportNameListComponent,
        CompanyListComponent,
        Employee1ListComponent,
        Employee2ListComponent,
        NewHrRequisitionLetterComponent,
        // RequisitionListComponent,
        // ReportRequisitionListComponent,
        // CurrencyListComponent,
        // SupplierListComponent,
        // ItemListComponent,
        // SourceTypeListComponent,
        // ItemHistoryListComponent,
        // PurchaseDetailsItemComponent,
        // ItemGroupListComponent,
        AdvanceSearchComponent,
        NewCompanyListComponent,
        HrCompanyListComponent,
        // WorkOrderStatusListComponent,
        // PurchaseContractStatusListComponent,
        // BillReturnAccountsInformationComponent,
        // RequisitionByStatusListComponent,
        // TermsAndConditionsComponent,
        // SelectTaskComponent,
        // StoreItemListComponent,
        ReportNameComponent,
        // StatusHistoryListComponent,
        // ItemParentListComponent,
        // ContactPersonListComponent,
        HrLineListOneComponent,
        HrBankNameListComponent,
        GradeListComponent,
        // SignatureByListComponent,
        // SignatoryByListComponent,
        HrLineListComponent,
        // WorkOrderDetailInformationListComponent,
        // StoreWiseOpBalListComponent,
        // StoreListComponent,
        // AccountInformationComponent,
        // VendorTypeListComponent,
        // ItemListTwoComponent,
        // LcTypeListComponent,
        // AccountsInformationTwoComponent,
        EmployeeListOneComponent,
        GradeListOneComponent,
        ReportNameListOneComponent,
        // HrLetterComponent,
        // BillIdListComponent,
        // SupplierLargeListComponent,
        // WorkOrderListComponent,
        // ProformaInvoiceListComponent,
        // HrEmployeeListComponent,
        // StoreTypeListComponent,
        // LcContractListComponent,
        // TransactionTypeListComponent,
        // TransactionListComponent,
        // PurchaseRequisitionComponent,
        // TermsAndConditionsComponentTwo,
        // TermListComponent,
        // TermsAndConditionsTemplateSetupComponent,
        // GroupAccountListComponent,
        // SupplierPiComponent,
        HrLineListTwoComponent,
        HrBusinessUnitList2Component,
        HrElementListComponent,
        HrShiftListComponent,
        HrJobTypeListComponent,
        HrJobTitleListComponent,
        HrEmployeeList2Component,
        HrProcessListComponent,
        HrFloorListComponent,
        // SupplierManufacturerComponent,
        // StockHistoryListComponent,
        // CnfListComponent,
        EmployeeListComponentTwo,
        PickPointListComponent,
        VehicleTypeListComponent,
        VehicleNoListComponent,
        HrReportListComponent,
        // StoreComponent,
        HrDateListComponent,
        // ProformaInvoiceListComponentTwo,
        // TermsAndConditionsSetupComponent,
        // TermsAndConditionsComponentThree
        /*============== HR Module Modals declarations ===============*/
        ,
        BusinessUnitOrgComponent,
        HrComShiftComponent,
        HrComLineComponent,
        HrFloorComponent,
        // HrReportNameListOneComponent,
        BaseComponent
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        SharedModule,
        VendorModule,
        DialogModule,
        BsDatepickerModule.forRoot(),
    ],
    exports: [
        CommonModule,
        HttpClientModule,
        BsDatepickerModule,
        BaseComponent
    ],
    providers: [
        TitleService,
        SpinnerService,
        RequestCache,
        { provide: ErrorHandler, useClass: CoreExceptionHandler },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule, titleService: TitleService) {
        titleService.init();
        WebStorageService.setUserGloablData();
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
